import {
  CBadge,
  CDropdown,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

const HeaderDropdownNotif = () => {
  const usage = useSelector((state: RootState) => state.limitUsage.current);

  const isWarning = usage !== null && usage.percentage >= 90;
  const isExceeded = usage !== null && usage.percentage >= 100;

  const badgeColor = isExceeded ? "danger" : "warning";
  const bellColor = isExceeded
    ? "text-danger"
    : isWarning
      ? "text-warning"
      : "";
  const itemColor = isExceeded
    ? "text-danger"
    : isWarning
      ? "text-warning"
      : "text-muted";
  const statusLabel = isExceeded
    ? "Límite alcanzado"
    : isWarning
      ? "Alcanzando límite"
      : null;

  return (
    <CDropdown inNav className="c-header-nav-item mx-2">
      <CDropdownToggle className="c-header-nav-link" caret={false}>
        <CIcon name="cil-bell" className={bellColor} />
        {isWarning && (
          <CBadge shape="pill" color={badgeColor}>
            !
          </CBadge>
        )}
      </CDropdownToggle>
      <CDropdownMenu placement="bottom-end" className="pt-0">
        <CDropdownHeader tag="div" className="text-center bg-light">
          <strong>Notificaciones</strong>
        </CDropdownHeader>
        {!isWarning ? (
          <CDropdownItem className="text-muted" style={{ textAlign: "center" }}>
            Sin notificaciones
          </CDropdownItem>
        ) : (
          <CDropdownItem className={itemColor}>
            Uso: {usage!.used} / {usage!.total} ({usage!.percentage}%)
            {statusLabel && <small>&nbsp;&nbsp;{statusLabel}</small>}
          </CDropdownItem>
        )}
      </CDropdownMenu>
    </CDropdown>
  );
};

export default HeaderDropdownNotif;
